import { BaseMultiProject, Folder, MultiProject, MultiReport, Project, ProjectPreview, Report, Unionize } from "fond/types";

export const EntityType = ["folder", "project", "report", "multi_project", "multi_report"] as const;
export type EntityType = Unionize<typeof EntityType>;

export type ResourceEntity = Folder | Project | ProjectPreview | MultiProject | BaseMultiProject | Report | MultiReport;

export const EntityLabel: Record<EntityType, string> = {
  folder: "folder",
  project: "project",
  report: "report",
  multi_project: "market lens",
  multi_report: "market lens report",
} as const;

export const ResourceType = {
  FOLDER: "folder",
  PROJECT: "project",
  MULTI_PROJECT: "market lens project",
  MULTI_REPORT: "market lens report",
  REPORT: "report",
} as const;
export type ResourceType = keyof typeof ResourceType;
